import React, { useState } from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetBody, SheetFooter } from '@/components/ui/sheet';
import { Modal } from '@/components/custom/modal/modal';
import { ModalWarning } from '@/components/custom/modal/modal-warning';
import {
  ModalSuccess,
  ModalSuccessBody,
  ModalSuccessContainer,
  ModalSuccessContent,
  ModalSuccessHeader,
  ModalSuccessImg,
  ModalSuccessKpi,
  ModalSuccessKpiIcon,
  ModalSuccessKpiInner,
  ModalSuccessKpiLabel,
  ModalSuccessKpiValue,
  ModalSuccessKpiWrapper,
  ModalSuccessName,
  ModalSuccessTag,
  ModalSuccessText,
  ModalSuccessTitle
} from '@/components/custom/modal/modal-success';
import { ModalScheduleDate, ModalScheduleHour, ModalScheduleText, ModalScheduleTitle } from '@/components/custom/modal/modal-schedule';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FiCalendar, FiClock, FiVideo } from 'react-icons/fi';

export function ModalsSection() {
  const [showBaseModal, setShowBaseModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSheet, setShowSheet] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);

  return (
    <ShowcaseSection
      id="modals"
      title="Modals & Overlays"
      description="Dialog, Modal, ModalSuccess, ModalWarning, ModalSchedule, Sheet"
    >
      <ShowcaseItem
        label="Dialog — Tamanhos"
        description="sm (464px), default (564px), md (810px), lg (900px)"
      >
        <div className="flex flex-wrap gap-2">
          {['sm', 'default', 'md', 'lg'].map(size => (
            <Dialog key={size}>
              <DialogTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                >
                  Dialog {size}
                </Button>
              </DialogTrigger>
              <DialogContent size={size}>
                <DialogHeader>
                  <DialogTitle>Dialog tamanho {size}</DialogTitle>
                  <DialogDescription>Este dialog usa o tamanho {size}.</DialogDescription>
                </DialogHeader>
                <div className="py-4">
                  <p className="text-sm text-neutral-dark">Conteudo do dialog aqui.</p>
                </div>
                <DialogFooter>
                  <DialogClose asChild>
                    <Button variant="outline">Cancelar</Button>
                  </DialogClose>
                  <DialogClose asChild>
                    <Button>Confirmar</Button>
                  </DialogClose>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Modal (custom)"
        description="Wrapper imperativo com show/onClose"
      >
        <Button onClick={() => setShowBaseModal(true)}>Abrir Modal</Button>
        <Modal
          show={showBaseModal}
          onClose={() => setShowBaseModal(false)}
        >
          <DialogHeader>
            <DialogTitle>Modal customizado</DialogTitle>
            <DialogDescription>Wrapper imperativo do Dialog que aceita props show e onClose.</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={() => setShowBaseModal(false)}>Fechar</Button>
          </DialogFooter>
        </Modal>
      </ShowcaseItem>

      <ShowcaseItem
        label="ModalWarning"
        description="Modal de confirmacao com 2 botoes (cancelar / confirmar)"
      >
        <Button
          variant="destructive"
          onClick={() => setShowWarning(true)}
        >
          Excluir item
        </Button>
        <ModalWarning
          show={showWarning}
          onClose={() => setShowWarning(false)}
          title="Tem certeza?"
          description="Essa acao nao pode ser desfeita. O item sera removido permanentemente."
          titleFirstButton="Cancelar"
          titleSecondButton="Sim, excluir"
          onSubmitFirstButton={() => setShowWarning(false)}
          onSubmitSecondButton={() => setShowWarning(false)}
        />
      </ShowcaseItem>

      <ShowcaseItem
        label="ModalSuccess"
        description="Modal de conclusao com tag, imagem, titulo, descricao e KPIs"
      >
        <Button
          variant="success"
          onClick={() => setShowSuccess(true)}
        >
          Abrir modal de sucesso
        </Button>
        {showSuccess && (
          <ModalSuccess
            isActive
            onClick={() => setShowSuccess(false)}
          >
            <ModalSuccessContent onClick={e => e.stopPropagation()}>
              <ModalSuccessTag>Concluido</ModalSuccessTag>
              <ModalSuccessImg
                src="https://i.pravatar.cc/200?img=15"
                alt="trofeu"
              />
              <ModalSuccessContainer>
                <ModalSuccessHeader>
                  <ModalSuccessTitle>Parabens! Voce concluiu o modulo</ModalSuccessTitle>
                </ModalSuccessHeader>
                <ModalSuccessBody>
                  <ModalSuccessText>Voce completou todas as aulas do modulo.</ModalSuccessText>
                  <ModalSuccessName>Matematica Basica - Modulo 1</ModalSuccessName>
                  <ModalSuccessKpiWrapper>
                    <ModalSuccessKpi>
                      <ModalSuccessKpiIcon>
                        <FiVideo />
                      </ModalSuccessKpiIcon>
                      <ModalSuccessKpiInner>
                        <ModalSuccessKpiValue>12</ModalSuccessKpiValue>
                        <ModalSuccessKpiLabel>Aulas assistidas</ModalSuccessKpiLabel>
                      </ModalSuccessKpiInner>
                    </ModalSuccessKpi>
                    <ModalSuccessKpi>
                      <ModalSuccessKpiIcon>
                        <FiClock />
                      </ModalSuccessKpiIcon>
                      <ModalSuccessKpiInner>
                        <ModalSuccessKpiValue>4h30</ModalSuccessKpiValue>
                        <ModalSuccessKpiLabel>Tempo total</ModalSuccessKpiLabel>
                      </ModalSuccessKpiInner>
                    </ModalSuccessKpi>
                  </ModalSuccessKpiWrapper>
                  <Button
                    fullWidth
                    onClick={() => setShowSuccess(false)}
                  >
                    Continuar
                  </Button>
                </ModalSuccessBody>
              </ModalSuccessContainer>
            </ModalSuccessContent>
          </ModalSuccess>
        )}
      </ShowcaseItem>

      <ShowcaseItem
        label="ModalSchedule (em Sheet)"
        description="Detalhes de evento agendado dentro de um Sheet lateral"
      >
        <Button
          variant="outline"
          onClick={() => setShowSchedule(true)}
        >
          <FiCalendar size={16} /> Ver detalhes do evento
        </Button>
        <Sheet
          open={showSchedule}
          onOpenChange={setShowSchedule}
        >
          <SheetContent>
            <SheetHeader>
              <SheetTitle>Detalhes do evento</SheetTitle>
              <SheetDescription>Informacoes da aula ao vivo agendada</SheetDescription>
            </SheetHeader>
            <SheetBody className="space-y-6">
              <ModalScheduleTitle>Aula ao vivo - Algebra Linear</ModalScheduleTitle>
              <ModalScheduleDate>16/04/2026</ModalScheduleDate>
              <ModalScheduleHour>19:00 - 20:30</ModalScheduleHour>
              <ModalScheduleText>Revisao geral do modulo de algebra linear, incluindo exercicios resolvidos e tira-duvidas.</ModalScheduleText>
            </SheetBody>
            <SheetFooter>
              <Button>Entrar na aula</Button>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </ShowcaseItem>

      <ShowcaseItem
        label="Sheet (drawer lateral)"
        description="Painel lateral controlado por open/onOpenChange"
      >
        <Button onClick={() => setShowSheet(true)}>Abrir Sheet</Button>
        <Sheet
          open={showSheet}
          onOpenChange={setShowSheet}
        >
          <SheetContent>
            <SheetHeader>
              <SheetTitle>Adicionar material</SheetTitle>
              <SheetDescription>Faca o upload de um novo material para o modulo</SheetDescription>
            </SheetHeader>
            <SheetBody className="space-y-4">
              <div>
                <Label className="mb-1">Nome do arquivo</Label>
                <Input placeholder="Ex: Apostila de revisao" />
              </div>
              <div>
                <Label className="mb-1">Descricao</Label>
                <Input placeholder="Breve descricao do material" />
              </div>
            </SheetBody>
            <SheetFooter>
              <Button
                variant="outline"
                onClick={() => setShowSheet(false)}
              >
                Cancelar
              </Button>
              <Button onClick={() => setShowSheet(false)}>Salvar</Button>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </ShowcaseItem>

      <ShowcaseItem
        label="Dialog hideCloseButton"
        description="Dialog sem botao X (forca acao via botao)"
      >
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">Abrir sem botao X</Button>
          </DialogTrigger>
          <DialogContent hideCloseButton>
            <DialogHeader>
              <DialogTitle>Dialog sem fechar</DialogTitle>
              <DialogDescription>Este dialog nao mostra o botao X. Use o botao abaixo.</DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button>Entendi</Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
